import type { HotelAccommodationDescriptionSuccess } from "app/features/hotel/hotelDescription/types";
import { computedProductTripadvisor } from "app/utils/utils";

/** Aligns a cached accommodation description on the shape `ficheProduitReducer` stores. */
export const mapAccommodationDescriptionToFicheProduit = (
	description: HotelAccommodationDescriptionSuccess
) => ({
	...description,
	status: "SUCCESS" as const,
	tripAdvisor: computedProductTripadvisor(description.tripadvisor),
});
